module.exports = __webpack_public_path__ + "img/01-T.7e956bad.png";